/**
 * Static swoosh arrow matching the logo curve.
 * Always visible above section titles.
 */
export function SectionArrow() {
  return (
    <div className="flex justify-center mb-4 h-[32px]">
      <svg
        width="160"
        height="32"
        viewBox="0 0 160 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="overflow-visible"
      >
        <path
          d="M6 26 C 36 4, 116 4, 148 24"
          stroke="var(--color-brand)"
          strokeWidth="1.8"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M138 12 L150 24 L136 26"
          stroke="var(--color-brand)"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
    </div>
  );
}
